import { storableError } from '../../util/errors';
import { updateProfile as updateProfileAction } from '../ProfileSettingsPage/ProfileSettingsPage.duck';

// ================ Action types ================ //
export const UPDATE_STORE_HOURS_REQUEST =
    'app/StoreHoursPage/UPDATE_STORE_HOURS_REQUEST';
export const UPDATE_STORE_HOURS_SUCCESS =
    'app/StoreHoursPage/UPDATE_STORE_HOURS_SUCCESS';
export const UPDATE_STORE_HOURS_ERROR =
    'app/StoreHoursPage/UPDATE_STORE_HOURS_ERROR';

// ================ Action creators ================ //
export const updateStoreHoursRequest = () => ({ type: UPDATE_STORE_HOURS_REQUEST });
export const updateStoreHoursSuccess = () => ({ type: UPDATE_STORE_HOURS_SUCCESS });
export const updateStoreHoursError = error => ({
    type: UPDATE_STORE_HOURS_ERROR,
    error: true,
    payload: error,
});

// ================ Reducer ================ //
const initialState = {
    updateInProgress: false,
    updateError: null,
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_STORE_HOURS_REQUEST:
            return {
                ...state,
                updateInProgress: true,
                updateError: null,
            };
        case UPDATE_STORE_HOURS_SUCCESS:
            return {
                ...state,
                updateInProgress: false,
                updateError: null,
            };
        case UPDATE_STORE_HOURS_ERROR:
            return {
                ...state,
                updateInProgress: false,
                updateError: payload,
            };
        default:
            return state;
    }
}

// ================ Selectors ================ //
export const getUpdateInProgress = state =>
    state.StoreHoursPage?.updateInProgress || false;

export const getUpdateError = state =>
    state.StoreHoursPage?.updateError;

// ================ Thunks ================ //
export const updateStoreHours = (formValues, currentUser) => {
    return async (dispatch, getState, sdk) => {
        dispatch(updateStoreHoursRequest());

        try {
            const {
                storeHours,
                exceptions,
            } = formValues;

            // Prepare publicData payload
            const publicDataPayload = {
                storeHours,
                exceptions,
            };

            const payload = {
                publicData: publicDataPayload,
            };

            // Call updateProfile thunk from ProfileSettingsPage
            await dispatch(updateProfileAction(payload));

            dispatch(updateStoreHoursSuccess());
            return true;
        } catch (error) {
            console.error('Error updating store hours:', error);
            const storableErr = storableError(error);
            dispatch(updateStoreHoursError(storableErr));
            return false;
        }
    };
};

// ================ loadData ================ //
export const loadData = (params, search, config) => (dispatch, getState) => {
    return Promise.resolve();
};
